<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">[コース情報]画面への入り方</li>
                        <li @click="scrollToElement('vn-2')">コース検索</li>
                        <li @click="scrollToElement('vn-3')">コース情報</li>
                        <li @click="scrollToElement('vn-4')">受講者一覧</li>
                        <li @click="scrollToElement('vn-5')">問題集一覧</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1.[コース情報]画面への入り方</h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-1.png" alt="" /></div>
                <div>
                    <p>①[ログインユーザアイコン]をクリックし、管理者用の管理メニューを開きます。</p>
                    <p>②[コース情報]をクリックすると、コースを管理する[コース情報]画面が表示されます。</p>
                </div>
                <div id="vn-2">
                    <h1>2.コース検索</h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-2.png" alt="" /></div>
                <div>
                    <p>検索したいコースの名称を入力してください。</p>
                </div>
                <div id="vn-3">
                    <h1>3.コース情報</h1>
                </div>
                <div>
                    <p>
                        <b><i>3.1.詳細内容</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-3.png" alt="" /></div>
                <div>
                    <p>[コース紹介]ボタンをクリックし、[コース詳細]画面に遷移します。</p>
                </div>
                <div>
                    <p>
                        <b><i>3.2.受講者成績のエクスポート</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-4.png" alt="" /></div>
                <div>
                    <p>[成績出力]ボタンをクリックし、このコースに参加している各受講社の成績情報をExcelファイルに出力されます。</p>
                </div>
                <div id="vn-4">
                    <h1>4.受講者一覧</h1>
                </div>
                <div>
                    <p>
                        <b><i>4.1.キーワード検索</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-5.png" alt="" /></div>
                <div>
                    <p>検索したい受講者の名前を入力してください。</p>
                </div>
                <div>
                    <p>
                        <b><i>4.2.受講者の学習状態で表示</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-6.png" alt="" /></div>
                <div>
                    <p>スイッチコントロールをクリックし、「学習状態」にて受講者を絞って表示します</p>
                </div>
                <div>
                    <p>
                        <b><i>4.3.受講者の学習状況詳細</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-7.png" alt="" /></div>
                <div>
                    <p>学習状況の詳細を確認したい受講者をクリックしてください。</p>
                </div>
                <div>
                    <p>
                        <b><i>4.4.小テストの回答状況</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-8.png" alt="" /></div>
                <div>
                    <p>小テストの得点率をクリックし、小テストの回答内容を確認することができます。</p>
                </div>
                <div id="vn-5">
                    <h1>5.問題一覧</h1>
                </div>
                <div>
                    <p>
                        <b><i>5.1.問題の検索</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-9.png" alt="" /></div>
                <div>
                    <p>① 検索条件に問題のIDを入力してください。</p>
                    <p>② 検索条件に問題のタイトルを入力してください。</p>
                    <p>③ 検索条件に問題の形式を選択してください。</p>
                    <p>④ 検索条件に問題の分類を選択してください。</p>
                    <p>⑤ 検索条件に問題の作成講師を選択してください。</p>
                    <p>⑥ 検索条件に問題の作成日を選択してください。</p>
                    <p>⑦ 検索条件に問題の章を選択してください。</p>                   
                    <p>⑧ 検索条件に問題に含まれるコンテンツ種類をチェックしてください（複数可）。</p>
                    <p>⑨ 検索条件を全てクリアします。</p>
                </div>
                <div>
                    <p>
                        <b><i>5.2.問題の詳細</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageCourseManual-10.png" alt="" /></div>
                <div>
                    <p>問題の詳細内容を表示するには、問題をクリックしてください。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/manageCourse_manual.vue